/* eslint-disable react-hooks/exhaustive-deps */
import { MutableRefObject, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import environment from "environment";

import Select, { OptionTypeBase } from "react-select";
import {
  request,
  getSelfServiceConfiguration,
  getRequests,
  setCurrentData,
  getStatuses,
  getYears,
  testFilter,
  saveFiltersGrid,
  deleteSavedFilters,
  setRowsPerPage,
} from "../../store/modules/RequestStore";

import { user } from "../../store/modules/UserStore";
import { PaginationComponent } from "./Pagination";
import { IconVia } from "../../components/widgets/ViaIcon";

import { useGlobalContext } from "../../context";

import {
  ListContainer,
  Input,
  InputsSearchFilter,
} from "../../components/RequestPage/List/ListElements";

import { Request } from "../../components/RequestPage/List/List";
import Footer from "../../components/layout/Footer";
import { Link } from "react-router-dom";
import { searchTermTimeout } from "../../utils/TimeOut";

import "../../styles/requestList.css";

import saveFilterImg from "../../assets/images/floppy-disk.png";
import trashFilterImg from "../../assets/images/delete.png";
import refreshFilterImg from "../../assets/images/refresh-white.png";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { IconButton, Tooltip } from "@material-ui/core";
import { firstDay } from "@progress/kendo-intl";
import { RootState } from "../../store/store";
import { useTranslation } from "react-i18next";
import TranslatableText from "../../components/Multilanguage/TranslatableText";

const ListRequest = () => {
  const dispatch = useDispatch();

  const userDetails = useSelector(user);
  const requestsState = useSelector(request);
  const searchTimeout: MutableRefObject<any> = useRef();

  const { t } = useTranslation();

  const { setCurrentRequestID } = useGlobalContext();

  const [selectedState, setSelectedState] = useState<OptionTypeBase>([]);

  const [selectStateNew, setSelectedStateNew] = useState<OptionTypeBase>([]);

  const [showFilterSearch, setShowFilterSearch] = useState(false);

  const [searchCriteria, setSearchCriteria] = useState<string>("");

  const [valueFilterSearch, setValueFilterSearch] = useState<number | null>(
    null
  );

  // const [rowsPerPage, setRowsPerPage] = useState(50);

  const rowsPerPage	= useSelector((state: RootState) => state.request.rowsPerPage || 10);

  const [selectOptionsFilterSearch, setSelectOptionsFilterSearch] =
    useState<OptionTypeBase>([]);

  const optionsFilterSearch = [
    { value: "1", label: t("requestAll.optionsFilterSearch.code") },
    { value: "2", label:  t("requestAll.optionsFilterSearch.subject") },
  ];

  const [selectedYear, setSelectedYear] = useState<OptionTypeBase>([
    { value: String(new Date().getFullYear()), label: String(new Date().getFullYear()) },
  ]);

  const filterDaysOptions = [
    { value: "1", label: t("requestAll.optionsFilterDays.today") },
    { value: "2", label: t("requestAll.optionsFilterDays.yesterday") },
    { value: "3", label: t("requestAll.optionsFilterDays.thisWeek") },
    { value: "4", label: t("requestAll.optionsFilterDays.last30Days") },
    { value: "5", label: t("requestAll.optionsFilterDays.last60Days") },
    { value: "6", label: t("requestAll.optionsFilterDays.last180Days") },
    { value: "7", label: t("requestAll.optionsFilterDays.custom") },
  ];

  const [hideFiltersDays, setHideFiltersDays] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);

  const [selectFilterDays, setSelectFilterDays] = useState<any>(0);
 

  const [filterDays, setFilterDays] = useState(0);

  var today = new Date();
  var monthValue = String(today.getMonth() + 1).padStart(2, "0");
  let monthLabel = today.toLocaleString("es-ES", { month: "long" });

  const [selectedMonth] = useState<OptionTypeBase>({
    value: monthValue,
    label: monthLabel[0].toUpperCase() + monthLabel.slice(1),
  });

  useEffect(() => {
    dispatch(getYears(userDetails.username));
    dispatch(getSelfServiceConfiguration());
    // dispatch(getRequests(userDetails.username ?? ""));
    // dispatch(getStatuses());
    getFiltersGrid();
    return () => {
      dispatch(setRowsPerPage(10));
    };
  }, []);

   



  const getFiltersGrid = async () => {
    const token = localStorage.getItem("token") ?? "";
    const apiUrl = environment.api.url.toString();

    const uri = new URL(apiUrl + "/users/GetFilterGrid");

    uri.searchParams.append("token", token);
    uri.searchParams.append("gridName", "REQUEST_GRID");
    uri.searchParams.append("moduleId", "4");

    const requestOptions: any = {
      method: "GET",
      redirect: "follow",
    };

    await fetch(uri, requestOptions)
      .then((response: any) => response.json())
      .then((result: any) => handleSavedFilters(result))
      .catch((error: unknown) => console.warn(error))
      .finally();
  };

  const getCurrentPreviousYear = () => {
    const currentYear = new Date().getFullYear();
    const previousYear = currentYear - 1;

    return [previousYear, currentYear];
  }

  const handleSavedFilters = (filters: any) => {
    if (!filters || filters.Status !== "Ok") return;

    const values = filters?.Values;

    if (!values) return;

    const statusNew: string[] = values.newStatus || [];
    const filterSearchOption: number = values.filterSearchOption
      ? Number(values.filterSearchOption)
      : 0;
    const searchCriteria = values.searchCriteria || "";
    const timeFilterOption: number =
      values.timeFilterOption?.length > 0 ? values.timeFilterOption.at(0) : 0;

    const firtsDate = values.fechaInicial ? values.fechaInicial[0] : "";
    const secondDate = values.fechaFinal ? values.fechaFinal[0] : "";

    let states: any[] = [];
    const years: number[] = getCurrentPreviousYear();
    const month = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ];

    // Validación estados solicitud
    if (statusNew.length > 0) {
      statusNew.forEach((status) => {
        const requestState = requestsState.statesNew.find(
          (state) => state.label === status
        );

        if (requestState) states.push(requestState);
      });

      if (states.length < 1) return;

      setSelectedStateNew(states);
      setSelectedState(states);

      states = states.map((state: any) => {
        return state.value;
      });
    }

    // Validación estado por código/solicitud
    if (filterSearchOption > 0) {
      const filterSearchValue = optionsFilterSearch.find(
        (filter) => filter.value === filterSearchOption.toString()
      );

      if (!filterSearchValue) return;

      setShowFilterSearch(true);
      // filterSearch(filterSearchValue);
      setSelectOptionsFilterSearch(filterSearchValue);

      if (searchCriteria !== "" && filterSearchValue.value === "1") {
        handleCode(searchCriteria);
        setSearchCriteria(searchCriteria);
      } else if (searchCriteria !== "" && filterSearchValue.value === "2") {
        handleTerm(searchCriteria);
        setSearchCriteria(searchCriteria);
      }
    }

    // Validación opciones avanzadas
    if (timeFilterOption > 0) {
      const filterDayOption = filterDaysOptions.filter(
        (option) => option.value === timeFilterOption.toString()
      );

      if (!filterDayOption) return;

      const option: any = filterDayOption.at(0);
      const optionId = Number(option?.value);

      setHideFiltersDays(true);

      setShowCalendar(optionId === 7);

      setSelectFilterDays(option);

      setFilterDays(timeFilterOption);

      // handleFilterDays(option);
    }

    let fecha1: Date | string = "";
    let fecha2: Date | string = "";

    if (firtsDate !== "" && secondDate !== "") {

      fecha1 = new Date(firtsDate);
      fecha2 = new Date(secondDate);

      fecha1.setMinutes(fecha1.getMinutes() + fecha1.getTimezoneOffset());
      fecha2.setMinutes(fecha2.getMinutes() + fecha2.getTimezoneOffset());



      const arrayDates = [fecha1, fecha2];

      setStartDate(fecha1);
      setEndDate(fecha2);

      // if (timeFilterOption === 7) {
      //   selectRangeFilterDays(arrayDates);
      // }
    }

    dispatch(
      testFilter(
        userDetails.username,
        states,
        years,
        searchCriteria,
        searchCriteria,
        month,
        0,
        timeFilterOption,
        firtsDate,
        secondDate
      )
    );
  };

  const handleStatus = (e: any) => {
    setSelectedStateNew(e);

    setSelectedState(e);

    if (filterDays === 0) {
      const states: number[] = [];

      const month = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ];

      e.forEach((element: any) => {
        states.push(element.value);
      });

      const years: number[] = getCurrentPreviousYear();

      // years.push(2022, 2023);

      let newOffset = 0;

      // if (page > 1) newOffset = (page - 1) * pageLimit;

      dispatch(
        testFilter(
          userDetails.username,
          states,
          years,
          term,
          requestID,
          month,
          newOffset
        )
      );

      handlePages(1);
    } else if (filterDays !== 0 && filterDays !== 7) {
      const states: number[] = [];

      e.forEach((element: any) => {
        states.push(element.value);
      });

      const years: number[] = [];

      const month: string[] = [];

      let newOffset = 0;

      // if (page > 1) newOffset = (page - 1) * pageLimit;

      handlePages(1);

      dispatch(
        testFilter(
          userDetails.username,
          states,
          years,
          term,
          requestID,
          month,
          newOffset,
          filterDays
        )
      );
    } else if (filterDays === 7) {
      const customFirstDate = JSON.stringify(startDate);
      const customSecondDate = JSON.stringify(endDate);

      var date1 = customFirstDate;
      var date2 = customSecondDate;

      var indexOfTimeChar = date1.indexOf("T");

      date1 = date1.substring(1, indexOfTimeChar);
      date2 = date2.substring(1, indexOfTimeChar);

      const states: number[] = [];

      e.forEach((element: any) => {
        states.push(element.value);
      });

      const years: number[] = [];

      const month: string[] = [];

      let newOffset = 0;

      if (page > 1) newOffset = (page - 1) * pageLimit;

      dispatch(
        testFilter(
          userDetails.username,
          states,
          years,
          term,
          requestID,
          month,
          newOffset,
          filterDays,
          date1,
          date2
        )
      );
    }
  };

  const handleCode = (code: string) => {
    // if (code === '') return;

    setRequestID(code);
    const states: number[] = [];

    selectedState.forEach((element: any) => {
      states.push(element.value);
    });

    const years: number[] = [];

    selectedYear.forEach((element: any) => {
      years.push(element.value);
    });

    let newOffset = 0;

    // if (page > 1) newOffset = (page - 1) * pageLimit;

    handlePages(1);

    clearTimeout(searchTimeout.current);

    if (code === "" && states.length > 0) {
      const allYears = getCurrentPreviousYear();

      const allMonth = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ];

      dispatch(
        testFilter(
          userDetails.username,
          states,
          allYears,
          term,
          code,
          allMonth,
          newOffset
        )
      );
    } else if (filterDays > 0 && filterDays < 7) {
      searchTimeout.current = setTimeout(() => {
        dispatch(
          testFilter(
            userDetails.username,
            states,
            years,
            term,
            code,
            selectedMonth.value,
            newOffset,
            filterDays
          )
        );
      }, searchTermTimeout);
    } else if (code === "" && filterDays > 0 && filterDays < 7) {
      searchTimeout.current = setTimeout(() => {
        dispatch(
          testFilter(
            userDetails.username,
            states,
            years,
            term,
            code,
            selectedMonth.value,
            newOffset,
            filterDays
          )
        );
      }, searchTermTimeout);
    } else if (code === "") {
      dispatch(getRequests(userDetails.username ?? ""));
    } else {
      searchTimeout.current = setTimeout(() => {
        dispatch(
          testFilter(
            userDetails.username,
            states,
            years,
            term,
            code,
            selectedMonth.value,
            newOffset
          )
        );
      }, searchTermTimeout);
    }
  };

  const [term, setTerm] = useState("");

  const handleTerm = (newTerm: string) => {
    if (newTerm === "") return;

    setTerm(newTerm);

    clearTimeout(searchTimeout.current);

    const states: number[] = [];

    let newOffset = 0;

    selectedState.forEach((element: any) => {
      states.push(element.value);
    });

    const years: number[] = getCurrentPreviousYear();

    //years.push(2022, 2023);

    if (states.length > 0 && filterDays === 0) {
      const month = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ];

      clearTimeout(searchTimeout.current);

      searchTimeout.current = setTimeout(() => {
        dispatch(
          testFilter(
            userDetails.username,
            states,
            years,
            newTerm,
            requestID,
            month,
            newOffset
          )
        );
      }, searchTermTimeout);
    } else if (
      states.length > 0 &&
      filterDays > 0 &&
      filterDays < 7 &&
      term !== ""
    ) {
      const years: number[] = [];

      const month: string[] = [];

      searchTimeout.current = setTimeout(() => {
        dispatch(
          testFilter(
            userDetails.username,
            states,
            years,
            newTerm,
            requestID,
            month,
            newOffset
          )
        );
      }, searchTermTimeout);
    } else {
      const states = [1, 2, 3, 4, 5, 6, 9, 11, 12];

      const years: number[] = getCurrentPreviousYear();

     // years.push(2022, 2023);

      const month = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ];

      handlePages(1);

      clearTimeout(searchTimeout.current);

      searchTimeout.current = setTimeout(() => {
        dispatch(
          testFilter(
            userDetails.username,
            states,
            years,
            newTerm,
            requestID,
            month,
            newOffset
          )
        );
      }, searchTermTimeout);
    }
  };

  const [requestID, setRequestID] = useState("");

  const [page, setPage] = useState(1);
  const pageLimit = 10;

  const handlePages = (updatePage: number) => {
    let newOffset = 0;

    if (updatePage > 1) newOffset = (updatePage - 1) * pageLimit;

    dispatch(setCurrentData(newOffset));

    setPage(updatePage);
  };

  const showFilterDays = () => {
    setShowCalendar(false);
    setHideFiltersDays(!hideFiltersDays);
    setFilterDays(0);

    // if (Object.entries(selectStateNew).length === 0) {
    //   dispatch(getRequests(userDetails.username ?? ""));
    // }
  };

  const handleFilterDays = (e: any) => {
    setSelectFilterDays(e);

    const convertFilterDays = parseInt(e.value);

    setFilterDays(convertFilterDays);

    if (e.value === "7") {
      setShowCalendar(true);
    } else {
      setShowCalendar(false);

      let timeFilterOption = e.value;

      const states: number[] = [];

      selectedState.forEach((element: any) => {
        states.push(element.value);
      });

      const years: number[] = [];
      selectedYear.forEach((element: any) => {
        years.push(element.value);
      });

      let newOffset = 0;

      // if (page > 1) newOffset = (page - 1) * pageLimit;

      handlePages(1);

      searchTimeout.current = setTimeout(() => {
        dispatch(
          testFilter(
            userDetails.username,
            states,
            years,
            term,
            requestID,
            selectedMonth.value,
            newOffset,
            timeFilterOption
          )
        );
      }, searchTermTimeout);
    }
  };

  const filterSearch = (e: any) => {
    setSelectOptionsFilterSearch(e);

    const states: number[] = [];

    selectedState.forEach((element: any) => {
      states.push(element.value);
    });

    if (e) {
      setShowFilterSearch(true);
      if (e.value === "1") {
        setTerm("");
        setSearchCriteria("");
        setValueFilterSearch(1);
        handlePages(1);

        const years = getCurrentPreviousYear();

        const allMonth = [
          "01",
          "02",
          "03",
          "04",
          "05",
          "06",
          "07",
          "08",
          "09",
          "10",
          "11",
          "12",
        ];

        if (states.length > 0 && filterDays === 0) {
          const term = "";

          searchTimeout.current = setTimeout(() => {
            dispatch(
              testFilter(
                userDetails.username,
                states,
                years,
                term,
                requestID,
                allMonth
              )
            );
          }, searchTermTimeout);
        } else if (states.length > 0 && filterDays > 0 && filterDays < 7) {
          const term = "";

          const timeFilterOption = filterDays;

          let newOffset = 0;

          handlePages(1);

          searchTimeout.current = setTimeout(() => {
            dispatch(
              testFilter(
                userDetails.username,
                states,
                years,
                term,
                requestID,
                allMonth,
                newOffset,
                timeFilterOption
              )
            );
          }, searchTermTimeout);
        } else {
          dispatch(getRequests(userDetails.username ?? ""));
        }
      } else if (e.value === "2") {
        if (filterDays === 7) {
        }

        setRequestID("");
        setSearchCriteria("");
        handlePages(1);
        setValueFilterSearch(2);
        const years = getCurrentPreviousYear();

        const allMonth = [
          "01",
          "02",
          "03",
          "04",
          "05",
          "06",
          "07",
          "08",
          "09",
          "10",
          "11",
          "12",
        ];

        const code = "";

        if (states.length > 0 && filterDays === 0) {
          searchTimeout.current = setTimeout(() => {
            dispatch(
              testFilter(
                userDetails.username,
                states,
                years,
                term,
                code,
                allMonth
              )
            );
          }, searchTermTimeout);
        } else if (
          states.length > 0 &&
          filterDays > 0 &&
          filterDays < 7 &&
          term === ""
        ) {
          const code = "";

          const timeFilterOption = filterDays;

          let newOffset = 0;

          handlePages(1);

          searchTimeout.current = setTimeout(() => {
            dispatch(
              testFilter(
                userDetails.username,
                states,
                years,
                term,
                code,
                allMonth,
                newOffset,
                timeFilterOption
              )
            );
          }, searchTermTimeout);
        } else {
          dispatch(getRequests(userDetails.username ?? ""));
        }
      }
    }
  };

  const handleSearchCriteria = (criteria: string) => {
    setSearchCriteria(criteria);
    handlePages(1);

    const selectOptionsValue = selectOptionsFilterSearch.value
      ? Number(selectOptionsFilterSearch.value)
      : 0;

    if (selectOptionsValue === 1) {
      handlePages(1);
      handleCode(criteria);
    } else if (selectOptionsValue === 2) {
      handleTerm(criteria);
    }
  };

  const saveFilters = () => {
    const selectedStates: string[] = selectedState.map(
      (state: OptionTypeBase) => {
        return state.label;
      }
    );

    const selectOptionFilterSearch = selectOptionsFilterSearch?.value;

    const selectedFilterDay = selectFilterDays;

    let date1 = "";
    let date2 = "";

    if (startDate !== null && endDate !== null) {
      const customFirstDate = JSON.stringify(startDate);
      const customSecondDate = JSON.stringify(endDate);

      date1 = customFirstDate;
      date2 = customSecondDate;

      var indexOfTimeChar = date1.indexOf("T");

      date1 = date1.substring(1, indexOfTimeChar);
      date2 = date2.substring(1, indexOfTimeChar);
    }

    dispatch(
      saveFiltersGrid(
        selectedStates,
        selectOptionFilterSearch,
        searchCriteria,
        selectedFilterDay,
        date1,
        date2
      )
    );
  };

  const deleteFilters = () => {
    setSelectedStateNew([]);
    setSelectedState([]);
    setFilterDays(0);
    setSelectOptionsFilterSearch([]);
    setSearchCriteria("");
    setShowFilterSearch(false);

    setSelectFilterDays([]);
    setHideFiltersDays(false);
    setShowCalendar(false);

    setStartDate(null);
    setEndDate(null);

    dispatch(deleteSavedFilters());
    dispatch(getRequests(userDetails.username ?? ""));
  };

  const loadData = (code: string) => {
    const states: number[] = [];

    selectedState.forEach((element: any) => {
      states.push(element.value);
    });

    const years: number[] = [];

    selectedYear.forEach((element: any) => {
      years.push(element.value);
    });

    let newOffset = 0;

    if (page > 1) newOffset = (page - 1) * pageLimit;

    dispatch(
      testFilter(
        userDetails.username,
        states,
        years,
        term,
        code,
        selectedMonth.value,
        newOffset
      )
    );
  };

  const [startDate, setStartDate] = useState<Date | null | undefined>(
    new Date()
  );
  const [endDate, setEndDate] = useState<Date | null | undefined>(null);

  const selectRangeFilterDays = (dates: any) => {
    const [start, end] = dates;

    setStartDate(start);
    setEndDate(end);

    const customFirstDate = JSON.stringify(start);
    const customSecondDate = JSON.stringify(end);

    var date1 = customFirstDate;
    var date2 = customSecondDate;

    var indexOfTimeChar = date1.indexOf("T");

    date1 = date1.substring(1, indexOfTimeChar);
    date2 = date2.substring(1, indexOfTimeChar);

    localStorage.setItem("date1", date1);
    localStorage.setItem("date2", date2);

    let timeFilterOption = 7;

    const states: number[] = [];

    selectedState.forEach((element: any) => {
      states.push(element.value);
    });

    const years: number[] = [];
    selectedYear.forEach((element: any) => {
      years.push(element.value);
    });

    let newOffset = 0;

    handlePages(1);

    searchTimeout.current = setTimeout(() => {
      dispatch(
        testFilter(
          userDetails.username,
          states,
          years,
          term,
          requestID,
          selectedMonth.value,
          newOffset,
          timeFilterOption,
          date1,
          date2
        )
      );
    }, searchTermTimeout);
  };

  return (
    <div>
      <div className="containerRequestList">
        <div className="arrow">
          <Link to={"/"}>
            <svg
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 17L6 12M6 12L11 7M6 12L18 12"
                stroke="#111827"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </div>
        <div className="state">
          <Select
            value={selectStateNew}
            onChange={(e) => handleStatus(e)}
            options={requestsState.statesNew.map((data) => {
              return {...data, label: <TranslatableText text={data.label} />}
            })}
            isMulti
            placeholder={t("requestAll.requestState")}
          />
        </div>
        <div className="iconsFilters">
          {/* Botón guardar filtros */}
          <Tooltip title={t("requestAll.tooltipSaveFilters")}>
            <img
              className="iconSave"
              onClick={saveFilters}
              src={saveFilterImg}
              width="30px"
              height="27px"
              alt="imgSave"
            />
          </Tooltip>
          {/* Botón eliminar filtros */}
          <Tooltip title={t("requestAll.tooltipDeleteFilters")}>
            <img
              className="iconDelete"
              onClick={deleteFilters}
              src={trashFilterImg}
              width="30px"
              height={"27px"}
              alt="deleteImg"
            />
          </Tooltip>
          {/* Botón recargar grilla */}
          {/* <img
            className="iconReload"
            onClick={reloadData}
            src={refreshFilterImg}
            width="30px"
            alt="reloadImg"
          /> */}
        </div>
        <div className="avancedOptions">
          <p onClick={showFilterDays} className="optionsFiltersDays">
            {t("requestAll.avancedOptions")}
          </p>
        </div>
        {hideFiltersDays && (
          <div className="selectFiltersDays">
            <Select
              value={selectFilterDays}
              onChange={(e) => handleFilterDays(e)}
              options={filterDaysOptions}
              placeholder={t("requestAll.placeholderDaysFilter")}
            />
          </div>
        )}
        {showCalendar && (
          <div className="searchFilter">
            <DatePicker
              wrapperClassName="datePicker"
              selected={startDate}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              onChange={selectRangeFilterDays}
              dateFormat={"yyyy-MM-dd"}
            />
          </div>
        )}
      </div>

      <div className="containerFilterSearch">
        <div className="optionFilterSearch">
          <Select
            value={selectOptionsFilterSearch}
            onChange={(e) => filterSearch(e)}
            options={optionsFilterSearch}
            placeholder={t("requestAll.placeholderSearchFilter")}
          />
        </div>
        <div className="filterSearch">
          {showFilterSearch && (
            <InputsSearchFilter>
              <Input
                value={searchCriteria}
                placeholder={t("requestAll.placeholderSearch")}
                className="border-gray-300 rounded-md mx-1 p-2  w-10/12 z-0 outline-none border"
                onChange={(e: any) => handleSearchCriteria(e.target.value)}
              />
            </InputsSearchFilter>
          )}
        </div>
      </div>
      <div></div>
      <ListContainer>
        {requestsState.pageData
          .slice()
          .sort((x, y) =>
            Number.parseInt(x.requestID) > Number.parseInt(y.requestID) ? -1 : 1
          )
          .map((request, index) => {
            return (
              <Request
                key={index}
                setCurrentRequestID={setCurrentRequestID}
                rq={request}
                IconVia={IconVia}
              />
            );
          })}
      </ListContainer>

      <div className="flex items-center justify-center my-4">
        {requestsState.pageData.length !== 0 && (
          <PaginationComponent
            page={page}
            totalPages={Math.ceil(requestsState.pagesTotal)}
            handlePagination={handlePages}
            rowsPerPage={rowsPerPage}
            storeType="request"
          />
        )}
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default ListRequest;
